export interface CategoryInfo {
  name: string;
  description: string;
  count: number;
  icon: string;
}

export interface ArticleItem {
  id: string;
  title: string;
  slug: string;
  category: string;
  excerpt: string;
  content: string;
  author: string;
  publishDate: string;
  readTime: number;
  tags: string[];
}

export const categories: Record<string, CategoryInfo> = {
  business: {
    name: '商务文件',
    description: '合同、协议、商业计划书、投标文件等专业商务文档起草服务',
    count: 3,
    icon: 'ri-file-text-line',
  },
  creative: {
    name: '创意文案',
    description: '广告文案、品牌故事、社交媒体内容、营销策划等创意写作服务',
    count: 2,
    icon: 'ri-lightbulb-line',
  },
  legal: {
    name: '法律文书',
    description: '起诉状、答辩状、法律意见书、律师函等法律文书起草与审核',
    count: 2,
    icon: 'ri-scales-line',
  },
  administrative: {
    name: '行政公文',
    description: '通知、请示、报告、会议纪要等行政公文规范化起草',
    count: 1,
    icon: 'ri-government-line',
  },
  academic: {
    name: '学术论文',
    description: '学术论文、研究报告、文献综述、开题报告等学术写作辅导',
    count: 2,
    icon: 'ri-book-open-line',
  },
  personal: {
    name: '个人文书',
    description: '简历、求职信、个人陈述、演讲稿等个人用途文书起草',
    count: 2,
    icon: 'ri-user-line',
  },
};

export const articles: ArticleItem[] = [
  {
    id: '1',
    title: '如何起草一份标准的企业采购合同',
    slug: 'procurement-contract-guide',
    category: 'business',
    excerpt: '企业采购合同是商业活动中最常见的法律文件之一。本文详细讲解采购合同的必备条款、注意事项以及起草技巧，帮助企业管理者和法务人员快速掌握采购合同的标准写法。',
    content: '<h2>采购合同的重要性</h2><p>在企业日常经营活动中，采购合同是最基础也是最重要的法律文件之一。一份规范的采购合同不仅能够明确双方权利义务，还能在发生纠纷时提供有力的法律保障。</p><h2>必备条款</h2><p><strong>1. 合同主体信息</strong>：明确买卖双方的完整名称、地址、联系方式及法定代表人信息。</p><p><strong>2. 标的物描述</strong>：详细描述采购物品的名称、规格、型号、数量、质量标准等关键参数。</p><p><strong>3. 价格与付款方式</strong>：明确单价、总价、币种，以及付款节点、付款比例和付款方式。建议采用分期付款以降低双方风险。</p><p><strong>4. 交货条款</strong>：约定交货时间、地点、运输方式以及风险转移节点。明确延迟交货的处理方式。</p><p><strong>5. 验收标准</strong>：制定明确的验收流程、标准和期限。验收不合格的处理方案应一并写入。</p><p><strong>6. 违约责任</strong>：约定双方违约情形及相应的责任承担方式，包括违约金计算标准。</p><p><strong>7. 争议解决</strong>：选择仲裁或诉讼作为争议解决方式，并明确管辖机构。</p><h2>起草技巧</h2><p>在起草采购合同时，建议注意以下几点：使用清晰明确的语言，避免模糊表述；关键条款需逐条审核，确保逻辑严密；根据实际交易情况灵活调整条款内容；建议在签订前由专业法律人士审核。</p>',
    author: '张明远',
    publishDate: '2026-07-28',
    readTime: 8,
    tags: ['采购合同', '商务文件', '合同起草', '企业法务'],
  },
  {
    id: '2',
    title: '商业计划书撰写指南：从零到融资',
    slug: 'business-plan-writing',
    category: 'business',
    excerpt: '一份优秀的商业计划书是创业者获得投资的关键。本文从市场分析、财务预测、团队介绍等方面，系统讲解商业计划书的标准写法。',
    content: '<h2>商业计划书的核心价值</h2><p>商业计划书不仅是融资的敲门砖，更是创业者梳理商业逻辑、明确发展方向的重要工具。一份高质量的商业计划书能让投资人在短时间内理解你的商业模式和价值主张。</p><h2>标准结构</h2><p><strong>1. 执行摘要</strong>：用一页篇幅概括整个商业计划的核心内容，包括产品/服务、目标市场、竞争优势、财务预测和融资需求。这是投资人最先阅读的部分，必须精炼有力。</p><p><strong>2. 公司简介</strong>：介绍公司基本信息、发展历程、愿景使命和核心团队背景。</p><p><strong>3. 市场分析</strong>：行业现状、市场规模、目标客户画像、竞争格局分析。</p><p><strong>4. 产品与服务</strong>：详细描述产品功能、技术优势、知识产权情况。</p><p><strong>5. 营销策略</strong>：定价策略、渠道策略、推广方案。</p><p><strong>6. 财务预测</strong>：未来3-5年的收入预测、成本结构和盈利分析。</p><h2>常见误区</h2><p>许多创业者在撰写商业计划书时容易陷入以下误区：过度乐观的市场预测、忽视竞争对手分析、财务数据缺乏依据、团队介绍过于简略。避免这些误区，你的商业计划书将更具说服力。</p>',
    author: '李思源',
    publishDate: '2026-07-25',
    readTime: 12,
    tags: ['商业计划书', '创业融资', '商务文件', '市场分析'],
  },
  {
    id: '3',
    title: '投标文件编制的关键要点与实战技巧',
    slug: 'bid-document-tips',
    category: 'business',
    excerpt: '投标文件的质量直接影响中标率。本文总结了投标文件编制的核心要点，帮助企业在激烈的竞争中脱颖而出。',
    content: '<h2>投标文件的重要性</h2><p>在政府采购和企业招标项目中，投标文件是评审委员会了解投标人实力和方案的最主要依据。一份专业规范的投标文件是中标的基础保障。</p><h2>编制要点</h2><p><strong>1. 研读招标文件</strong>：仔细阅读招标文件的每一项要求，确保完全理解招标人的需求和评分标准。标记关键条款和废标条款，防止因疏忽导致废标。</p><p><strong>2. 商务部分</strong>：包括投标函、法定代表人授权书、营业执照、资质证书、财务报表、业绩证明等。确保所有证照在有效期内。</p><p><strong>3. 技术部分</strong>：详细阐述技术方案、实施方案、质量保证措施、售后服务方案等。技术方案要紧扣招标需求，突出自身优势。</p><p><strong>4. 报价部分</strong>：合理定价，既要有竞争力又要确保利润空间。注意报价的完整性和一致性，避免不同部分的报价出现矛盾。</p><h2>实战技巧</h2><p>制作响应性检查清单，逐条对照招标文件要求，确保无遗漏。重视细节：排版规范、装订整齐、签章完整，给评审留下良好的第一印象。</p>',
    author: '王建国',
    publishDate: '2026-07-20',
    readTime: 10,
    tags: ['投标文件', '政府采购', '商务文件', '项目管理'],
  },
  {
    id: '4',
    title: '品牌故事写作：让消费者记住你的品牌',
    slug: 'brand-story-writing',
    category: 'creative',
    excerpt: '一个好的品牌故事胜过千言万语的广告。本文分享如何撰写打动人心的品牌故事，建立与消费者之间的情感连接。',
    content: '<h2>品牌故事的力量</h2><p>在信息爆炸的时代，消费者每天接触成千上万的广告信息。只有那些能触动人心的品牌故事，才能在消费者记忆中留下深刻印象。品牌故事不是虚构的小说，而是品牌核心价值观的真实表达。</p><h2>品牌故事的核心要素</h2><p><strong>1. 创始人故事</strong>：讲述创始人为什么创立这个品牌，背后的初心和使命感。</p><p><strong>2. 品牌使命</strong>：品牌想要解决什么问题？为消费者创造什么价值？</p><p><strong>3. 冲突与转折</strong>：品牌发展过程中经历了哪些挑战？如何克服困难的？</p><p><strong>4. 价值观共鸣</strong>：品牌代表什么样的价值观？与目标消费者有什么共鸣点？</p><h2>写作技巧</h2><p>使用第一人称或第三人称叙事，增强代入感。注重细节描写，让故事更加生动真实。保持真诚，避免过度包装。结尾要有行动号召，引导消费者参与品牌故事。</p>',
    author: '陈雨萱',
    publishDate: '2026-07-22',
    readTime: 6,
    tags: ['品牌故事', '创意文案', '品牌营销', '内容创作'],
  },
  {
    id: '5',
    title: '社交媒体文案的黄金法则',
    slug: 'social-media-copywriting',
    category: 'creative',
    excerpt: '社交媒体文案与传统广告文案有着本质区别。本文总结社交媒体文案创作的黄金法则，助你提升内容传播效果。',
    content: '<h2>社交媒体文案的特点</h2><p>社交媒体文案具有即时性、互动性和碎片化的特点。用户注意力极为有限，需要在短时间内抓住眼球、传递信息、激发行动。</p><h2>黄金法则</h2><p><strong>法则一：前三秒定生死</strong>——开头必须极具吸引力，可以用提问、数据、故事或争议性观点开头。</p><p><strong>法则二：说人话</strong>——使用目标受众熟悉的语言风格，避免官方腔和行业黑话。越自然越有亲和力。</p><p><strong>法则三：一个文案一个目的</strong>——每条文案只传达一个核心信息或一个行动号召。</p><p><strong>法则四：视觉先行</strong>——配图、视频或表情符号能大幅提升文案的阅读率和传播率。</p><p><strong>法则五：制造互动</strong>——在文案中设置互动环节，如投票、提问、征集意见等。</p>',
    author: '陈雨萱',
    publishDate: '2026-07-18',
    readTime: 7,
    tags: ['社交媒体', '文案创作', '内容营销', '新媒体运营'],
  },
  {
    id: '6',
    title: '律师函起草规范与注意事项',
    slug: 'lawyer-letter-drafting',
    category: 'legal',
    excerpt: '律师函是律师执业中常用的法律文书，具有法律严肃性和正式性。本文详述律师函的格式规范、内容要点及起草注意事项。',
    content: '<h2>律师函的法律意义</h2><p>律师函是律师事务所接受当事人委托出具的正式法律文件，具有通知、警示、催告等法律功能。一封措辞恰当、格式规范的律师函往往能起到化解纠纷的作用，避免进入诉讼程序。</p><h2>格式规范</h2><p><strong>1. 律所抬头</strong>：使用律师事务所官方信笺，包含律所名称、地址、联系方式。</p><p><strong>2. 文书编号</strong>：按照律所文书管理制度编写统一编号。</p><p><strong>3. 收件人信息</strong>：完整填写收件人名称及地址。</p><p><strong>4. 正文内容</strong>：事实陈述、法律依据、律师意见、具体要求。</p><p><strong>5. 落款盖章</strong>：律师签名、律所盖章、日期。</p><h2>内容要点</h2><p>事实陈述要客观准确，附相关证据材料。法律分析要有明确的法律条文依据。律师意见要清晰明确。具体要求要有合理期限。</p>',
    author: '赵明诚',
    publishDate: '2026-07-15',
    readTime: 9,
    tags: ['律师函', '法律文书', '律师实务', '法律写作'],
  },
  {
    id: '7',
    title: '民事起诉状撰写全攻略',
    slug: 'civil-complaint-guide',
    category: 'legal',
    excerpt: '民事起诉状是启动民事诉讼程序的必要文书。本文从诉讼请求、事实与理由、证据清单等方面，全面讲解民事起诉状的撰写方法。',
    content: '<h2>民事起诉状的基本要求</h2><p>根据《民事诉讼法》的规定，起诉状应当记明原告、被告的基本信息、诉讼请求和所根据的事实与理由、证据和证据来源等内容。格式规范、内容完整是法院受理案件的基本前提。</p><h2>撰写步骤</h2><p><strong>第一步：确定当事人信息</strong>——原告和被告的姓名、性别、出生日期、民族、住址、联系方式等。</p><p><strong>第二步：明确诉讼请求</strong>——这是起诉状最核心的部分。诉讼请求要具体、明确、可执行。例如"判令被告支付货款人民币XX元及逾期利息"。</p><p><strong>第三步：陈述事实与理由</strong>——按时间顺序清晰陈述案件事实，引用相关法律条文作为诉讼依据。</p><p><strong>第四步：列明证据清单</strong>——逐一列明证据名称、证明内容和来源。</p>',
    author: '赵明诚',
    publishDate: '2026-07-10',
    readTime: 11,
    tags: ['民事起诉状', '民事诉讼', '法律文书', '诉讼实务'],
  },
  {
    id: '8',
    title: '行政公文写作规范与格式标准',
    slug: 'official-document-format',
    category: 'administrative',
    excerpt: '行政公文是国家机关、企事业单位在日常工作中使用的重要文书。本文详解行政公文的法定格式规范和写作标准。',
    content: '<h2>行政公文的基本特征</h2><p>行政公文具有法定性、规范性、权威性和时效性。每一份行政公文都必须符合国家规定的格式标准，这是公文严肃性和权威性的基本保障。</p><h2>格式要素</h2><p><strong>1. 版头</strong>：包括发文机关标志、发文字号、签发人等。</p><p><strong>2. 主体</strong>：标题、主送机关、正文、附件说明、发文机关署名、成文日期、印章。</p><p><strong>3. 版记</strong>：抄送机关、印发机关、印发日期等。</p><h2>常用公文类型</h2><p><strong>通知</strong>：用于发布、传达要求下级机关执行的事项，要求语言简洁明了，事项具体明确。</p><p><strong>请示</strong>：用于向上级机关请求指示、批准，要求一文一事，理由充分。</p>',
    author: '刘志远',
    publishDate: '2026-07-08',
    readTime: 8,
    tags: ['行政公文', '公文写作', '机关文书', '办公技能'],
  },
  {
    id: '9',
    title: '学术论文摘要写作方法论',
    slug: 'academic-abstract-writing',
    category: 'academic',
    excerpt: '摘要是一篇学术论文的精华浓缩，直接决定审稿人和读者是否继续阅读全文。本文系统讲解学术论文摘要的标准写法。',
    content: '<h2>摘要的重要性</h2><p>摘要是学术论文的"门面"，是读者和审稿人接触论文的第一印象。在学术数据库中，摘要往往是被检索和阅读的唯一部分。一篇好的摘要能大幅提升论文的引用率和影响力。</p><h2>标准结构</h2><p><strong>1. 研究背景</strong>：用1-2句话介绍研究领域和问题背景。</p><p><strong>2. 研究目的</strong>：明确说明本研究要解决什么问题。</p><p><strong>3. 研究方法</strong>：简述采用的研究方法、实验设计和数据分析手段。</p><p><strong>4. 研究结果</strong>：报告主要研究发现和数据结果。</p><p><strong>5. 研究结论</strong>：总结研究贡献、理论意义和实践价值。</p><h2>写作要点</h2><p>字数控制在200-300字为宜。使用第三人称，避免使用"本文"、"作者"等词语。数据要具体准确。关键词3-5个，按逻辑顺序排列。</p>',
    author: '周文博',
    publishDate: '2026-07-05',
    readTime: 6,
    tags: ['学术论文', '摘要写作', '研究方法', '学术写作'],
  },
  {
    id: '10',
    title: '文献综述的写作框架与技巧',
    slug: 'literature-review-guide',
    category: 'academic',
    excerpt: '文献综述是学术研究的基础性工作，也是学位论文的重要组成部分。本文提供文献综述的标准写作框架和实用技巧。',
    content: '<h2>文献综述的目的</h2><p>文献综述不是简单的文献罗列，而是对已有研究成果的系统梳理和批判性分析。通过文献综述，研究者可以明确自己的研究在学术版图中的位置，找到研究空白和创新点。</p><h2>写作框架</h2><p><strong>1. 引言部分</strong>：说明综述主题的范围和重要性，概述文献检索策略和筛选标准。</p><p><strong>2. 主体部分</strong>：按主题、时间或方法论组织文献，对每类文献进行分析、比较和评价。</p><p><strong>3. 总结部分</strong>：归纳已有研究的主要贡献和不足，指出未来研究方向。</p><h2>常见问题</h2><p>文献堆砌缺乏分析、缺少对文献的批判性评价、引用过时文献、忽视经典研究和最新研究的平衡。避免这些问题，你的文献综述将更具学术价值。</p>',
    author: '周文博',
    publishDate: '2026-07-01',
    readTime: 10,
    tags: ['文献综述', '学术写作', '研究方法', '论文写作'],
  },
  {
    id: '11',
    title: '令人眼前一亮的简历应该这样写',
    slug: 'resume-writing-tips',
    category: 'personal',
    excerpt: '简历是求职者给招聘方的第一张名片。本文分享简历撰写的核心原则和实用技巧，助你在众多求职者中脱颖而出。',
    content: '<h2>简历的本质</h2><p>简历不是人生履历的简单罗列，而是一份说服招聘方"为什么应该面试你"的营销文案。每一句话都应该服务于这个核心目的。</p><h2>核心原则</h2><p><strong>1. 结果导向</strong>：不只是列职责，要写明你做了什么、取得了什么成果。使用具体数据支撑。</p><p><strong>2. 针对性定制</strong>：根据不同职位和公司调整简历内容。研究目标公司的业务和职位要求，将相关经验和技能前置。</p><p><strong>3. 简洁清晰</strong>：控制在1-2页。使用清晰的层级结构和要点列表。</p><p><strong>4. 关键词优化</strong>：包含职位描述中的关键词，便于ATS识别。</p><h2>加分要素</h2><p>项目经验展示完整的项目周期和你的具体贡献。技能证书与职位直接相关的专业证书更具说服力。作品集链接适用于设计、编程、写作等岗位。</p>',
    author: '林小雅',
    publishDate: '2026-06-28',
    readTime: 7,
    tags: ['简历写作', '求职技巧', '个人文书', '职业发展'],
  },
  {
    id: '12',
    title: '演讲稿撰写的五步法',
    slug: 'speech-writing-method',
    category: 'personal',
    excerpt: '一篇优秀的演讲稿需要兼顾内容逻辑、情感表达和现场效果。本文分享演讲稿创作五步法，帮你轻松搞定各类演讲场合。',
    content: '<h2>演讲的本质</h2><p>演讲是信息的传递，更是情感的交流。一篇好的演讲稿要能够让听众"听进去"、"记得住"、"有感受"。撰写演讲稿需要同时考虑内容和表达两个层面。</p><h2>五步创作法</h2><p><strong>第一步：定主题</strong>——确定演讲的核心信息。用一句话概括你想让听众记住什么。</p><p><strong>第二步：建框架</strong>——开场（吸引注意）→ 主体（展开论述，3个要点为宜）→ 结尾（总结升华，行动号召）。</p><p><strong>第三步：填内容</strong>——每个要点配以案例、数据或故事支撑。故事是最有效的说服工具。</p><p><strong>第四步：润语言</strong>——使用口语化表达，长短句结合，适当使用排比、反问等修辞手法。</p><p><strong>第五步：加互动</strong>——在合适位置设计互动环节，提问、举手、小调查等。</p>',
    author: '林小雅',
    publishDate: '2026-06-22',
    readTime: 8,
    tags: ['演讲稿', '表达技巧', '个人文书', '公众演讲'],
  },
];

export const faqs = [
  {
    question: '17.c-起草口 是什么？',
    answer: '17.c-起草口 是一个专业的在线文案起草平台，提供一站式草稿撰写、内容规划与文件起草服务。无论您需要起草商务文件、合同草案、创意文案还是学术论文，17.c-起草口 都能为您提供专业的写作指导和模板支持。',
  },
  {
    question: '17.c-起草口 适合哪些用户群体？',
    answer: '17.c-起草口 面向广泛的用户群体，包括企业管理者、法务人员、创业者、市场营销人员、行政文员、学术研究者以及有个人文书需求的普通用户。无论是商务场景还是个人需求，17.c-起草口 都能提供针对性的起草解决方案。',
  },
  {
    question: '在 17.c-起草口 上起草的文件是否具有法律效力？',
    answer: '17.c-起草口 提供的是专业的起草指导和模板参考服务。我们的内容由资深专业人士撰写，符合行业规范和法律要求。但对于涉及重大权益的法律文件，我们建议在正式使用前咨询专业律师进行审核，以确保完全符合您的具体情况和法律要求。',
  },
  {
    question: '17.c-起草口 的内容多久更新一次？',
    answer: '17.c-起草口 的内容团队持续关注法律法规变化、行业动态和写作趋势，定期更新平台内容。我们每周发布新的起草指南和实用文章，确保用户始终获取最新、最准确的专业起草知识。',
  },
  {
    question: '如何在 17.c-起草口 上找到我需要的起草指南？',
    answer: '您可以通过首页的服务分类导航快速定位所需内容类型，也可以使用分类页面的标签切换功能浏览不同类别下的全部文章。每篇文章都配有详细的标签，方便您通过关联内容深入了解更多起草知识。',
  },
  {
    question: '17.c-起草口 的内容是否可以转载？',
    answer: '17.c-起草口 的所有原创内容均受版权保护。如需转载或引用我们的内容，请注明出处并链接回原文。对于商业用途的转载需求，请通过关于我们页面的联系方式与我们取得授权。',
  },
];